import validate from "/opt/buildhome/repo/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/opt/buildhome/repo/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  onboarding: () => import("/opt/buildhome/repo/modules/auth/middleware/onboarding.ts"),
  verify: () => import("/opt/buildhome/repo/modules/auth/middleware/verify.ts"),
  worker: () => import("/opt/buildhome/repo/modules/auth/middleware/worker.ts"),
  auth: () => import("/opt/buildhome/repo/node_modules/@sidebase/nuxt-auth/dist/runtime/middleware/auth.js")
}